document.addEventListener('DOMContentLoaded', () => {
    const SCROLL_TOP_BREAKPOINT = 80;
    const body = document.body;
    let lastScrollPosition = 0;

    // Initial kontroll direkt när sidan laddas
    lastScrollPosition = getScrollPosition();
    checkScrollState();

    // Lyssna på scroll
    document.addEventListener('scroll', () => {
        requestAnimationFrame(checkScrollState);
    });

    function checkScrollState() {
        const currentScrollPosition = getScrollPosition();
        const classes = ['not-scrolled', 'header-scrolled', 'header-scrolled-up'];
        let classToAdd;

        if (currentScrollPosition <= SCROLL_TOP_BREAKPOINT) {
            classToAdd = 'not-scrolled';
        } else if (currentScrollPosition > lastScrollPosition) {
            classToAdd = 'header-scrolled';
        } else {
            classToAdd = 'header-scrolled-up';
        }

        // Ta bort övriga klasser och lägg till rätt
        body.classList.add(classToAdd);
        body.classList.remove(...classes.filter(c => c !== classToAdd));

        lastScrollPosition = currentScrollPosition;
    }

    function getScrollPosition() {
        return window.pageYOffset || document.documentElement.scrollTop;
    }
});

//# sourceMappingURL=header-scroll.js.map
